const FREQUENCY_RANGE_FACTORS = [
  [0.28, 0.65],
  [0.03, 0.5],
  [0.015, 0.35],
  [0.035, 0.5],
  [0.25, 0.67],
] as const;

export const getBarHeights = (
  frequencyData: Uint8Array,
  output = new Array<number>(FREQUENCY_RANGE_FACTORS.length)
) => {
  const fftSize = frequencyData.length;

  for (let band = 0; band < FREQUENCY_RANGE_FACTORS.length; band++) {
    const [startFactor, endFactor] = FREQUENCY_RANGE_FACTORS[band]!;
    const from = Math.floor(fftSize * startFactor);
    const to = Math.floor(fftSize * endFactor);
    let sum = 0;
    for (let i = from; i < to; i++) {
      sum += frequencyData[i] ?? 0;
    }
    const avg = to > from ? sum / (to - from) : 0;

    const randomness = Math.sin(Math.random() / 10) * 20 * Math.random() > 0.5 ? 1 : -1;
    output[band] = ((avg * 1.75) / 255) * 50 + randomness;
  }

  return output;
};
